import './HomeOrderTimeline.scss';

import classNames from 'classnames';

import { formatDate } from '@utils/helpers';

import type { HomeOrderTimelineProgress, HomeTimelineStep } from '../homeTimeline';

const stepDateText = (step: HomeTimelineStep): string | null => (step.date ? formatDate(step.date) : null);

interface HomeOrderTimelineProps {
  timeline: HomeOrderTimelineProgress;
}

export function HomeOrderTimeline({ timeline }: HomeOrderTimelineProps) {
  return (
    <ol className='home-timeline' data-testid='homeTimeline'>
      {timeline.steps.map(step => {
        const dateText = stepDateText(step);

        return (
          <li
            key={step.id}
            className={classNames('home-timeline__step', `home-timeline__step--${step.status}`)}
            aria-current={step.status === 'current' ? 'step' : undefined}
            data-testid={`homeTimelineStep-${step.id}`}
          >
            <span className='home-timeline__dot' aria-hidden='true' />
            <span className='home-timeline__label'>{step.label}</span>
            <span className='home-timeline__date'>{dateText}</span>
          </li>
        );
      })}
    </ol>
  );
}
